(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["overlay-pp-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-popup-subscribe')) {
    customElements.define(
      'pp-popup-subscribe',
      class extends HTMLElement {
        connectedCallback() {
          const form = this.querySelector('form');
          const openButton = this.querySelector('[data-pp-subscribe-open]');
          const fields = this.querySelector('[data-pp-subscribe-fields]');
          const email = this.querySelector('[data-pp-subscribe-email]');
          const controls = this.querySelector('[data-pp-subscribe-controls]');
          const success = this.querySelector('[data-pp-subscribe-success]');

          if (openButton && fields) {
            openButton.addEventListener('click', () => {
              openButton.setAttribute('aria-expanded', 'true');
              openButton.remove();
              fields.hidden = false;
              email?.focus();
            });
          }

          if (!form || !controls || !success) return;

          form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const submitButton = form.querySelector('[type="submit"]');
            submitButton?.setAttribute('aria-busy', 'true');
            submitButton?.setAttribute('disabled', '');

            try {
              const response = await fetch(form.action, {
                method: 'POST',
                body: new FormData(form),
                headers: { Accept: 'text/html' },
              });
              const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
              const returnedForm = responseDocument.getElementById(form.id);
              const submittedSuccessfully =
                response.ok &&
                (returnedForm?.querySelector('[data-pp-subscribe-success]:not([hidden])') ||
                  response.url.includes('customer_posted=true'));

              if (!submittedSuccessfully) {
                const returnedErrors = returnedForm?.querySelector('.pp-popup__subscribe-errors');
                if (returnedErrors) {
                  const currentErrors = form.querySelector('.pp-popup__subscribe-errors');
                  currentErrors?.remove();
                  fields.prepend(returnedErrors);
                }
                return;
              }

              controls.remove();
              success.hidden = false;
              success.focus();
            } finally {
              submitButton?.removeAttribute('aria-busy');
              submitButton?.removeAttribute('disabled');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
